import {DeliveryStatusType, OrderDto} from '../../types'

/**
 * Delivery statuses that don't count towards order completion
 */
const nonRelevantDeliveryStatuses = [
  DeliveryStatusType.unknown,
  DeliveryStatusType.returned,
  DeliveryStatusType.cancelled
]

/**
 * Checks if all relevant deliveries have been invoiced
 */
export const allRelevantDeliveriesInvoiced = (order: OrderDto): boolean => {
  const relevant = (order.deliveries ?? []).filter(
    (d) => !nonRelevantDeliveryStatuses.includes(d.deliveryStatus)
  )
  if (relevant.length === 0) {
    return false
  }
  return relevant.every((d) => d.deliveryStatus === DeliveryStatusType.invoiced)
}

/**
 * Gets the minimum quantity required for the order
 */
export const minQuantity = (order: OrderDto): number => {
  const first = order.lineItems?.[0]
  return first?.minQuantity ?? first?.quantity ?? 0
}

/**
 * Determines if the last truck for the order has been loaded
 */
export const isLastTruckLoaded = (order: OrderDto): boolean => {
  const assigned = order.deliveryProgress?.assignedQuantity ?? 0
  return assigned >= minQuantity(order)
}
